import * as url from "../url_helper";

import { post, get } from "../api_helper";

export const addUser = data => post(url.ADD_USER, data);

export const getUser = data => post(url.GET_USER, data);

export const editUser = data => post(url.EDIT_USER, data);

export const AddSapUser = data => post(url.ADD_SAP_USER, data);

export const getSapUser = data => post(url.GET_SAP_USER, data);

export const editSapUser = data => post(url.EDIT_SAP_USER, data);

export const editUserStatus = data => post(url.EDIT_USER_STATUS, data)

export const getSapUserList = data => post(url.GET_SAP_USER_LIST, data);

export const getSapUserOptions = () => get(url.GET_SAP_USER_OPTIONS);

export const deleteSapUser = data => post(url.DELETE_SAP_USER, data);

export const getDealerUserList = data => post(url.GET_DEALER_USER_LIST, data);

export const addDealerUser = data => post(url.ADD_DEALER_USER, data);

export const updateDealerUser = data => post(url.EDIT_DEALER_USER, data);

export const getOneDealerUser = data => post(url.GET_ONE_DEALER_USER, data);






